import React from 'react';
import { FadeIn } from './FadeIn';
import { XCircle } from 'lucide-react';
export function FailedSolutionsSection() {
  const failures = ['Los analgésicos solo enmascaran el dolor por unas horas.', 'Las cremas tópicas parecen ayudar al inicio, pero no atacan la raíz del problema.', 'Los ejercicios complicados terminan causando más molestias que alivio.', 'Los remedios caseros no son sostenibles.'];
  return <section className="py-24 px-6 bg-cream-light" data-id="element-18">
      <div className="max-w-3xl mx-auto" data-id="element-19">
        <FadeIn data-id="element-20">
          <div className="text-center mb-16" data-id="element-21">
            <h3 className="text-3xl sm:text-4xl font-serif text-brown mb-6" data-id="element-22">
              ¿Por qué nada ha funcionado?
            </h3>
            <p className="text-lg text-brown-light" data-id="element-23">
              Es normal sentirse escéptica cuando has intentado de todo sin ver
              resultados duraderos.
            </p>
          </div>
        </FadeIn>

        <div className="space-y-6" data-id="element-24">
          {failures.map((text, index) => <FadeIn key={index} delay={0.1 * (index + 1)} data-id="element-25">
              <div className="flex items-start gap-4 p-6 bg-white rounded-xl shadow-sm border border-cream hover:border-terracotta/30 transition-colors duration-300" data-id="element-26">
                <div className="flex-shrink-0 mt-1" data-id="element-27">
                  <XCircle className="w-6 h-6 text-terracotta opacity-80" data-id="element-28" />
                </div>
                <p className="text-lg text-brown leading-relaxed" data-id="element-29">{text}</p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}